export const SCREEN_WIDTH = 1920;
export const SCREEN_HEIGHT = 1080;
export const EXPORT_TIMEOUT = 30000;
export const PDF_IMAGE_OFFSET = 30;
export const PDF_IMAGE_PADDING = PDF_IMAGE_OFFSET * 2;

export const FILE_EXTENSION = {
  PNG: 'png',
  PDF: 'pdf',
};
